const TIMEZONE = [
  {
    "id": "Pacific/Niue",
    "name": "(GMT-11:00) Niue"
  },
  {
    "id": "Pacific/Pago_Pago",
    "name": "(GMT-11:00) Pago Pago"
  },
  {
    "id": "Pacific/Honolulu",
    "name": "(GMT-10:00) Hawaii Time"
  },
  {
    "id": "Pacific/Rarotonga",
    "name": "(GMT-10:00) Rarotonga"
  },
  {
    "id": "Pacific/Tahiti",
    "name": "(GMT-10:00) Tahiti"
  },
  {
    "id": "Pacific/Marquesas",
    "name": "(GMT-09:30) Marquesas"
  },
  {
    "id": "America/Anchorage",
    "name": "(GMT-09:00) Alaska Time"
  },
  {
    "id": "Pacific/Gambier",
    "name": "(GMT-09:00) Gambier"
  },
  {
    "id": "America/Los_Angeles",
    "name": "(GMT-08:00) Pacific Time"
  },
  {
    "id": "America/Tijuana",
    "name": "(GMT-08:00) Pacific Time - Tijuana"
  },
  {
    "id": "America/Vancouver",
    "name": "(GMT-08:00) Pacific Time - Vancouver"
  },
  {
    "id": "America/Whitehorse",
    "name": "(GMT-08:00) Pacific Time - Whitehorse"
  },
  {
    "id": "Pacific/Pitcairn",
    "name": "(GMT-08:00) Pitcairn"
  },
  {
    "id": "America/Dawson_Creek",
    "name": "(GMT-07:00) Mountain Time - Dawson Creek"
  },
  {
    "id": "America/Denver",
    "name": "(GMT-07:00) Mountain Time"
  },
  {
    "id": "America/Edmonton",
    "name": "(GMT-07:00) Mountain Time - Edmonton"
  },
  {
    "id": "America/Hermosillo",
    "name": "(GMT-07:00) Mountain Time - Hermosillo"
  },
  {
    "id": "America/Mazatlan",
    "name": "(GMT-07:00) Mountain Time - Chihuahua, Mazatlan"
  },
  {
    "id": "America/Phoenix",
    "name": "(GMT-07:00) Mountain Time - Arizona"
  },
  {
    "id": "America/Yellowknife",
    "name": "(GMT-07:00) Mountain Time - Yellowknife"
  },
  {
    "id": "America/Belize",
    "name": "(GMT-06:00) Belize"
  },
  {
    "id": "America/Chicago",
    "name": "(GMT-06:00) Central Time"
  },
  {
    "id": "America/Costa_Rica",
    "name": "(GMT-06:00) Costa Rica"
  },
  {
    "id": "America/El_Salvador",
    "name": "(GMT-06:00) El Salvador"
  },
  {
    "id": "America/Guatemala",
    "name": "(GMT-06:00) Guatemala"
  },
  {
    "id": "America/Managua",
    "name": "(GMT-06:00) Managua"
  },
  {
    "id": "America/Mexico_City",
    "name": "(GMT-06:00) Central Time - Mexico City"
  },
  {
    "id": "America/Regina",
    "name": "(GMT-06:00) Central Time - Regina"
  },
  {
    "id": "America/Tegucigalpa",
    "name": "(GMT-06:00) Central Time - Tegucigalpa"
  },
  {
    "id": "America/Winnipeg",
    "name": "(GMT-06:00) Central Time - Winnipeg"
  },
  {
    "id": "Pacific/Galapagos",
    "name": "(GMT-06:00) Galapagos"
  },
  {
    "id": "America/Bogota",
    "name": "(GMT-05:00) Bogota"
  },
  {
    "id": "America/Cancun",
    "name": "(GMT-05:00) America Cancun"
  },
  {
    "id": "America/Cayman",
    "name": "(GMT-05:00) Cayman"
  },
  {
    "id": "America/Guayaquil",
    "name": "(GMT-05:00) Guayaquil"
  },
  {
    "id": "America/Havana",
    "name": "(GMT-05:00) Havana"
  },
  {
    "id": "America/Iqaluit",
    "name": "(GMT-05:00) Eastern Time - Iqaluit"
  },
  {
    "id": "America/Jamaica",
    "name": "(GMT-05:00) Jamaica"
  },
  {
    "id": "America/Lima",
    "name": "(GMT-05:00) Lima"
  },
  {
    "id": "America/Nassau",
    "name": "(GMT-05:00) Nassau"
  },
  {
    "id": "America/New_York",
    "name": "(GMT-05:00) Eastern Time"
  },
  {
    "id": "America/Panama",
    "name": "(GMT-05:00) Panama"
  },
  {
    "id": "America/Port-au-Prince",
    "name": "(GMT-05:00) Port-au-Prince"
  },
  {
    "id": "America/Rio_Branco",
    "name": "(GMT-05:00) Rio Branco"
  },
  {
    "id": "America/Toronto",
    "name": "(GMT-05:00) Eastern Time - Toronto"
  },
  {
    "id": "Pacific/Easter",
    "name": "(GMT-05:00) Easter Island"
  },
  {
    "id": "America/Caracas",
    "name": "(GMT-04:30) Caracas"
  },
  {
    "id": "America/Asuncion",
    "name": "(GMT-03:00) Asuncion"
  },
  {
    "id": "America/Barbados",
    "name": "(GMT-04:00) Barbados"
  },
  {
    "id": "America/Boa_Vista",
    "name": "(GMT-04:00) Boa Vista"
  },
  {
    "id": "America/Campo_Grande",
    "name": "(GMT-03:00) Campo Grande"
  },
  {
    "id": "America/Cuiaba",
    "name": "(GMT-03:00) Cuiaba"
  },
  {
    "id": "America/Curacao",
    "name": "(GMT-04:00) Curacao"
  },
  {
    "id": "America/Grand_Turk",
    "name": "(GMT-04:00) Grand Turk"
  },
  {
    "id": "America/Guyana",
    "name": "(GMT-04:00) Guyana"
  },
  {
    "id": "America/Halifax",
    "name": "(GMT-04:00) Atlantic Time - Halifax"
  },
  {
    "id": "America/La_Paz",
    "name": "(GMT-04:00) La Paz"
  },
  {
    "id": "America/Manaus",
    "name": "(GMT-04:00) Manaus"
  },
  {
    "id": "America/Martinique",
    "name": "(GMT-04:00) Martinique"
  },
  {
    "id": "America/Port_of_Spain",
    "name": "(GMT-04:00) Port of Spain"
  },
  {
    "id": "America/Porto_Velho",
    "name": "(GMT-04:00) Porto Velho"
  },
  {
    "id": "America/Puerto_Rico",
    "name": "(GMT-04:00) Puerto Rico"
  },
  {
    "id": "America/Santo_Domingo",
    "name": "(GMT-04:00) Santo Domingo"
  },
  {
    "id": "America/Thule",
    "name": "(GMT-04:00) Thule"
  },
  {
    "id": "Atlantic/Bermuda",
    "name": "(GMT-04:00) Bermuda"
  },
  {
    "id": "America/St_Johns",
    "name": "(GMT-03:30) Newfoundland Time - St. Johns"
  },
  {
    "id": "America/Araguaina",
    "name": "(GMT-03:00) Araguaina"
  },
  {
    "id": "America/Argentina/Buenos_Aires",
    "name": "(GMT-03:00) Buenos Aires"
  },
  {
    "id": "America/Bahia",
    "name": "(GMT-03:00) Salvador"
  },
  {
    "id": "America/Belem",
    "name": "(GMT-03:00) Belem"
  },
  {
    "id": "America/Cayenne",
    "name": "(GMT-03:00) Cayenne"
  },
  {
    "id": "America/Fortaleza",
    "name": "(GMT-03:00) Fortaleza"
  },
  {
    "id": "America/Godthab",
    "name": "(GMT-03:00) Godthab"
  },
  {
    "id": "America/Maceio",
    "name": "(GMT-03:00) Maceio"
  },
  {
    "id": "America/Miquelon",
    "name": "(GMT-03:00) Miquelon"
  },
  {
    "id": "America/Montevideo",
    "name": "(GMT-03:00) Montevideo"
  },
  {
    "id": "America/Paramaribo",
    "name": "(GMT-03:00) Paramaribo"
  },
  {
    "id": "America/Recife",
    "name": "(GMT-03:00) Recife"
  },
  {
    "id": "America/Santiago",
    "name": "(GMT-03:00) Santiago"
  },
  {
    "id": "America/Sao_Paulo",
    "name": "(GMT-02:00) Sao Paulo"
  },
  {
    "id": "Antarctica/Palmer",
    "name": "(GMT-03:00) Palmer"
  },
  {
    "id": "Antarctica/Rothera",
    "name": "(GMT-03:00) Rothera"
  },
  {
    "id": "Atlantic/Stanley",
    "name": "(GMT-03:00) Stanley"
  },
  {
    "id": "America/Noronha",
    "name": "(GMT-02:00) Noronha"
  },
  {
    "id": "Atlantic/South_Georgia",
    "name": "(GMT-02:00) South Georgia"
  },
  {
    "id": "America/Scoresbysund",
    "name": "(GMT-01:00) Scoresbysund"
  },
  {
    "id": "Atlantic/Azores",
    "name": "(GMT-01:00) Azores"
  },
  {
    "id": "Atlantic/Cape_Verde",
    "name": "(GMT-01:00) Cape Verde"
  },
  {
    "id": "Africa/Abidjan",
    "name": "(GMT+00:00) Abidjan"
  },
  {
    "id": "Africa/Accra",
    "name": "(GMT+00:00) Accra"
  },
  {
    "id": "Africa/Bissau",
    "name": "(GMT+00:00) Bissau"
  },
  {
    "id": "Africa/Casablanca",
    "name": "(GMT+00:00) Casablanca"
  },
  {
    "id": "Africa/El_Aaiun",
    "name": "(GMT+00:00) El Aaiun"
  },
  {
    "id": "Africa/Monrovia",
    "name": "(GMT+00:00) Monrovia"
  },
  {
    "id": "America/Danmarkshavn",
    "name": "(GMT+00:00) Danmarkshavn"
  },
  {
    "id": "Atlantic/Canary",
    "name": "(GMT+00:00) Canary Islands"
  },
  {
    "id": "Atlantic/Faroe",
    "name": "(GMT+00:00) Faeroe"
  },
  {
    "id": "Atlantic/Reykjavik",
    "name": "(GMT+00:00) Reykjavik"
  },
  {
    "id": "Etc/GMT",
    "name": "(GMT+00:00) GMT (no daylight saving)"
  },
  {
    "id": "Europe/Dublin",
    "name": "(GMT+00:00) Dublin"
  },
  {
    "id": "Europe/Lisbon",
    "name": "(GMT+00:00) Lisbon"
  },
  {
    "id": "Europe/London",
    "name": "(GMT+00:00) London"
  },
  {
    "id": "Africa/Algiers",
    "name": "(GMT+01:00) Algiers"
  },
  {
    "id": "Africa/Ceuta",
    "name": "(GMT+01:00) Ceuta"
  },
  {
    "id": "Africa/Lagos",
    "name": "(GMT+01:00) Lagos"
  },
  {
    "id": "Africa/Ndjamena",
    "name": "(GMT+01:00) Ndjamena"
  },
  {
    "id": "Africa/Tunis",
    "name": "(GMT+01:00) Tunis"
  },
  {
    "id": "Africa/Windhoek",
    "name": "(GMT+02:00) Windhoek"
  },
  {
    "id": "Europe/Amsterdam",
    "name": "(GMT+01:00) Amsterdam"
  },
  {
    "id": "Europe/Andorra",
    "name": "(GMT+01:00) Andorra"
  },
  {
    "id": "Europe/Belgrade",
    "name": "(GMT+01:00) Central European Time - Belgrade"
  },
  {
    "id": "Europe/Berlin",
    "name": "(GMT+01:00) Berlin"
  },
  {
    "id": "Europe/Brussels",
    "name": "(GMT+01:00) Brussels"
  },
  {
    "id": "Europe/Budapest",
    "name": "(GMT+01:00) Budapest"
  },
  {
    "id": "Europe/Copenhagen",
    "name": "(GMT+01:00) Copenhagen"
  },
  {
    "id": "Europe/Gibraltar",
    "name": "(GMT+01:00) Gibraltar"
  },
  {
    "id": "Europe/Luxembourg",
    "name": "(GMT+01:00) Luxembourg"
  },
  {
    "id": "Europe/Madrid",
    "name": "(GMT+01:00) Madrid"
  },
  {
    "id": "Europe/Malta",
    "name": "(GMT+01:00) Malta"
  },
  {
    "id": "Europe/Monaco",
    "name": "(GMT+01:00) Monaco"
  },
  {
    "id": "Europe/Oslo",
    "name": "(GMT+01:00) Oslo"
  },
  {
    "id": "Europe/Paris",
    "name": "(GMT+01:00) Paris"
  },
  {
    "id": "Europe/Prague",
    "name": "(GMT+01:00) Central European Time - Prague"
  },
  {
    "id": "Europe/Rome",
    "name": "(GMT+01:00) Rome"
  },
  {
    "id": "Europe/Stockholm",
    "name": "(GMT+01:00) Stockholm"
  },
  {
    "id": "Europe/Tirane",
    "name": "(GMT+01:00) Tirane"
  },
  {
    "id": "Europe/Vienna",
    "name": "(GMT+01:00) Vienna"
  },
  {
    "id": "Europe/Warsaw",
    "name": "(GMT+01:00) Warsaw"
  },
  {
    "id": "Europe/Zurich",
    "name": "(GMT+01:00) Zurich"
  },
  {
    "id": "Africa/Cairo",
    "name": "(GMT+02:00) Cairo"
  },
  {
    "id": "Africa/Johannesburg",
    "name": "(GMT+02:00) Johannesburg"
  },
  {
    "id": "Africa/Maputo",
    "name": "(GMT+02:00) Maputo"
  },
  {
    "id": "Africa/Tripoli",
    "name": "(GMT+02:00) Tripoli"
  },
  {
    "id": "Asia/Amman",
    "name": "(GMT+02:00) Amman"
  },
  {
    "id": "Asia/Beirut",
    "name": "(GMT+02:00) Beirut"
  },
  {
    "id": "Asia/Damascus",
    "name": "(GMT+02:00) Damascus"
  },
  {
    "id": "Asia/Gaza",
    "name": "(GMT+02:00) Gaza"
  },
  {
    "id": "Asia/Jerusalem",
    "name": "(GMT+02:00) Jerusalem"
  },
  {
    "id": "Asia/Nicosia",
    "name": "(GMT+02:00) Nicosia"
  },
  {
    "id": "Europe/Athens",
    "name": "(GMT+02:00) Athens"
  },
  {
    "id": "Europe/Bucharest",
    "name": "(GMT+02:00) Bucharest"
  },
  {
    "id": "Europe/Chisinau",
    "name": "(GMT+02:00) Chisinau"
  },
  {
    "id": "Europe/Helsinki",
    "name": "(GMT+02:00) Helsinki"
  },
  {
    "id": "Europe/Istanbul",
    "name": "(GMT+02:00) Istanbul"
  },
  {
    "id": "Europe/Kaliningrad",
    "name": "(GMT+02:00) Moscow-01 - Kaliningrad"
  },
  {
    "id": "Europe/Kiev",
    "name": "(GMT+02:00) Kiev"
  },
  {
    "id": "Europe/Riga",
    "name": "(GMT+02:00) Riga"
  },
  {
    "id": "Europe/Sofia",
    "name": "(GMT+02:00) Sofia"
  },
  {
    "id": "Europe/Tallinn",
    "name": "(GMT+02:00) Tallinn"
  },
  {
    "id": "Europe/Vilnius",
    "name": "(GMT+02:00) Vilnius"
  },
  {
    "id": "Africa/Khartoum",
    "name": "(GMT+03:00) Khartoum"
  },
  {
    "id": "Africa/Nairobi",
    "name": "(GMT+03:00) Nairobi"
  },
  {
    "id": "Antarctica/Syowa",
    "name": "(GMT+03:00) Syowa"
  },
  {
    "id": "Asia/Baghdad",
    "name": "(GMT+03:00) Baghdad"
  },
  {
    "id": "Asia/Qatar",
    "name": "(GMT+03:00) Qatar"
  },
  {
    "id": "Asia/Riyadh",
    "name": "(GMT+03:00) Riyadh"
  },
  {
    "id": "Europe/Minsk",
    "name": "(GMT+03:00) Minsk"
  },
  {
    "id": "Europe/Moscow",
    "name": "(GMT+03:00) Moscow+00 - Moscow"
  },
  {
    "id": "Asia/Tehran",
    "name": "(GMT+03:30) Tehran"
  },
  {
    "id": "Asia/Baku",
    "name": "(GMT+04:00) Baku"
  },
  {
    "id": "Asia/Dubai",
    "name": "(GMT+04:00) Dubai"
  },
  {
    "id": "Asia/Tbilisi",
    "name": "(GMT+04:00) Tbilisi"
  },
  {
    "id": "Asia/Yerevan",
    "name": "(GMT+04:00) Yerevan"
  },
  {
    "id": "Europe/Samara",
    "name": "(GMT+04:00) Moscow+01 - Samara"
  },
  {
    "id": "Indian/Mahe",
    "name": "(GMT+04:00) Mahe"
  },
  {
    "id": "Indian/Mauritius",
    "name": "(GMT+04:00) Mauritius"
  },
  {
    "id": "Indian/Reunion",
    "name": "(GMT+04:00) Reunion"
  },
  {
    "id": "Asia/Kabul",
    "name": "(GMT+04:30) Kabul"
  },
  {
    "id": "Antarctica/Mawson",
    "name": "(GMT+05:00) Mawson"
  },
  {
    "id": "Asia/Aqtau",
    "name": "(GMT+05:00) Aqtau"
  },
  {
    "id": "Asia/Aqtobe",
    "name": "(GMT+05:00) Aqtobe"
  },
  {
    "id": "Asia/Ashgabat",
    "name": "(GMT+05:00) Ashgabat"
  },
  {
    "id": "Asia/Dushanbe",
    "name": "(GMT+05:00) Dushanbe"
  },
  {
    "id": "Asia/Karachi",
    "name": "(GMT+05:00) Karachi"
  },
  {
    "id": "Asia/Tashkent",
    "name": "(GMT+05:00) Tashkent"
  },
  {
    "id": "Asia/Yekaterinburg",
    "name": "(GMT+05:00) Moscow+02 - Yekaterinburg"
  },
  {
    "id": "Indian/Kerguelen",
    "name": "(GMT+05:00) Kerguelen"
  },
  {
    "id": "Indian/Maldives",
    "name": "(GMT+05:00) Maldives"
  },
  {
    "id": "Asia/Calcutta",
    "name": "(GMT+05:30) India Standard Time"
  },
  {
    "id": "Asia/Colombo",
    "name": "(GMT+05:30) Colombo"
  },
  {
    "id": "Asia/Katmandu",
    "name": "(GMT+05:45) Katmandu"
  },
  {
    "id": "Antarctica/Vostok",
    "name": "(GMT+06:00) Vostok"
  },
  {
    "id": "Asia/Almaty",
    "name": "(GMT+06:00) Almaty"
  },
  {
    "id": "Asia/Bishkek",
    "name": "(GMT+06:00) Bishkek"
  },
  {
    "id": "Asia/Dhaka",
    "name": "(GMT+06:00) Dhaka"
  },
  {
    "id": "Asia/Omsk",
    "name": "(GMT+06:00) Moscow+03 - Omsk, Novosibirsk"
  },
  {
    "id": "Asia/Thimphu",
    "name": "(GMT+06:00) Thimphu"
  },
  {
    "id": "Indian/Chagos",
    "name": "(GMT+06:00) Chagos"
  },
  {
    "id": "Asia/Rangoon",
    "name": "(GMT+06:30) Rangoon"
  },
  {
    "id": "Indian/Cocos",
    "name": "(GMT+06:30) Cocos"
  },
  {
    "id": "Antarctica/Davis",
    "name": "(GMT+07:00) Davis"
  },
  {
    "id": "Asia/Bangkok",
    "name": "(GMT+07:00) Bangkok"
  },
  {
    "id": "Asia/Hovd",
    "name": "(GMT+07:00) Hovd"
  },
  {
    "id": "Asia/Jakarta",
    "name": "(GMT+07:00) Jakarta"
  },
  {
    "id": "Asia/Krasnoyarsk",
    "name": "(GMT+07:00) Moscow+04 - Krasnoyarsk"
  },
  {
    "id": "Asia/Saigon",
    "name": "(GMT+07:00) Hanoi"
  },
  {
    "id": "Indian/Christmas",
    "name": "(GMT+07:00) Christmas"
  },
  {
    "id": "Antarctica/Casey",
    "name": "(GMT+08:00) Casey"
  },
  {
    "id": "Asia/Brunei",
    "name": "(GMT+08:00) Brunei"
  },
  {
    "id": "Asia/Choibalsan",
    "name": "(GMT+08:00) Choibalsan"
  },
  {
    "id": "Asia/Hong_Kong",
    "name": "(GMT+08:00) Hong Kong"
  },
  {
    "id": "Asia/Irkutsk",
    "name": "(GMT+08:00) Moscow+05 - Irkutsk"
  },
  {
    "id": "Asia/Kuala_Lumpur",
    "name": "(GMT+08:00) Kuala Lumpur"
  },
  {
    "id": "Asia/Macau",
    "name": "(GMT+08:00) Macau"
  },
  {
    "id": "Asia/Makassar",
    "name": "(GMT+08:00) Makassar"
  },
  {
    "id": "Asia/Manila",
    "name": "(GMT+08:00) Manila"
  },
  {
    "id": "Asia/Shanghai",
    "name": "(GMT+08:00) China Time - Beijing"
  },
  {
    "id": "Asia/Singapore",
    "name": "(GMT+08:00) Singapore"
  },
  {
    "id": "Asia/Taipei",
    "name": "(GMT+08:00) Taipei"
  },
  {
    "id": "Asia/Ulaanbaatar",
    "name": "(GMT+08:00) Ulaanbaatar"
  },
  {
    "id": "Australia/Perth",
    "name": "(GMT+08:00) Western Time - Perth"
  },
  {
    "id": "Asia/Pyongyang",
    "name": "(GMT+08:30) Pyongyang"
  },
  {
    "id": "Asia/Dili",
    "name": "(GMT+09:00) Dili"
  },
  {
    "id": "Asia/Jayapura",
    "name": "(GMT+09:00) Jayapura"
  },
  {
    "id": "Asia/Seoul",
    "name": "(GMT+09:00) Seoul"
  },
  {
    "id": "Asia/Tokyo",
    "name": "(GMT+09:00) Tokyo"
  },
  {
    "id": "Asia/Yakutsk",
    "name": "(GMT+09:00) Moscow+06 - Yakutsk"
  },
  {
    "id": "Pacific/Palau",
    "name": "(GMT+09:00) Palau"
  },
  {
    "id": "Australia/Adelaide",
    "name": "(GMT+10:30) Central Time - Adelaide"
  },
  {
    "id": "Australia/Darwin",
    "name": "(GMT+09:30) Central Time - Darwin"
  },
  {
    "id": "Antarctica/DumontDUrville",
    "name": "(GMT+10:00) Dumont D'Urville"
  },
  {
    "id": "Asia/Magadan",
    "name": "(GMT+10:00) Moscow+07 - Magadan"
  },
  {
    "id": "Asia/Vladivostok",
    "name": "(GMT+10:00) Moscow+07 - Yuzhno-Sakhalinsk"
  },
  {
    "id": "Australia/Brisbane",
    "name": "(GMT+10:00) Eastern Time - Brisbane"
  },
  {
    "id": "Australia/Hobart",
    "name": "(GMT+11:00) Eastern Time - Hobart"
  },
  {
    "id": "Australia/Sydney",
    "name": "(GMT+11:00) Eastern Time - Melbourne, Sydney"
  },
  {
    "id": "Pacific/Chuuk",
    "name": "(GMT+10:00) Truk"
  },
  {
    "id": "Pacific/Guam",
    "name": "(GMT+10:00) Guam"
  },
  {
    "id": "Pacific/Port_Moresby",
    "name": "(GMT+10:00) Port Moresby"
  },
  {
    "id": "Pacific/Efate",
    "name": "(GMT+11:00) Efate"
  },
  {
    "id": "Pacific/Guadalcanal",
    "name": "(GMT+11:00) Guadalcanal"
  },
  {
    "id": "Pacific/Kosrae",
    "name": "(GMT+11:00) Kosrae"
  },
  {
    "id": "Pacific/Norfolk",
    "name": "(GMT+11:00) Norfolk"
  },
  {
    "id": "Pacific/Noumea",
    "name": "(GMT+11:00) Noumea"
  },
  {
    "id": "Pacific/Pohnpei",
    "name": "(GMT+11:00) Ponape"
  },
  {
    "id": "Asia/Kamchatka",
    "name": "(GMT+12:00) Moscow+09 - Petropavlovsk-Kamchatskiy"
  },
  {
    "id": "Pacific/Auckland",
    "name": "(GMT+13:00) Auckland"
  },
  {
    "id": "Pacific/Fiji",
    "name": "(GMT+13:00) Fiji"
  },
  {
    "id": "Pacific/Funafuti",
    "name": "(GMT+12:00) Funafuti"
  },
  {
    "id": "Pacific/Kwajalein",
    "name": "(GMT+12:00) Kwajalein"
  },
  {
    "id": "Pacific/Majuro",
    "name": "(GMT+12:00) Majuro"
  },
  {
    "id": "Pacific/Nauru",
    "name": "(GMT+12:00) Nauru"
  },
  {
    "id": "Pacific/Tarawa",
    "name": "(GMT+12:00) Tarawa"
  },
  {
    "id": "Pacific/Wake",
    "name": "(GMT+12:00) Wake"
  },
  {
    "id": "Pacific/Wallis",
    "name": "(GMT+12:00) Wallis"
  },
  {
    "id": "Pacific/Apia",
    "name": "(GMT+14:00) Apia"
  },
  {
    "id": "Pacific/Enderbury",
    "name": "(GMT+13:00) Enderbury"
  },
  {
    "id": "Pacific/Fakaofo",
    "name": "(GMT+13:00) Fakaofo"
  },
  {
    "id": "Pacific/Tongatapu",
    "name": "(GMT+13:00) Tongatapu"
  },
  {
    "id": "Pacific/Kiritimati",
    "name": "(GMT+14:00) Kiritimati"
  },
  {
    "id": "Africa/Addis_Ababa",
    "name": "(UTC+03:00) Nairobi"
  },
  {
    "id": "Africa/Bamako",
    "name": "(UTC) Monrovia, Reykjavik"
  },
  {
    "id": "Africa/Bangui",
    "name": "(UTC+01:00) West Central Africa"
  },
  {
    "id": "Africa/Banjul",
    "name": "(UTC) Monrovia, Reykjavik"
  },
  {
    "id": "Africa/Blantyre",
    "name": "(UTC+02:00) Harare, Pretoria"
  },
  {
    "id": "Africa/Brazzaville",
    "name": "(UTC+01:00) West Central Africa"
  },
  {
    "id": "Africa/Bujumbura",
    "name": "(UTC+02:00) Harare, Pretoria"
  },
  {
    "id": "Asia/Oral",
    "name": "(UTC+05:00) Ashgabat, Tashkent"
  },
  {
    "id": "Africa/Conakry",
    "name": "(UTC) Monrovia, Reykjavik"
  },
  {
    "id": "Africa/Dakar",
    "name": "(UTC) Monrovia, Reykjavik"
  },
  {
    "id": "Africa/Dar_es_Salaam",
    "name": "(UTC+03:00) Nairobi"
  },
  {
    "id": "Africa/Douala",
    "name": "(UTC+01:00) West Central Africa"
  },
  {
    "id": "Africa/Freetown",
    "name": "(UTC) Monrovia, Reykjavik"
  },
  {
    "id": "Africa/Gaborone",
    "name": "(UTC+02:00) Harare, Pretoria"
  },
  {
    "id": "Africa/Harare",
    "name": "(UTC+02:00) Harare, Pretoria"
  },
  {
    "id": "Africa/Juba",
    "name": "(UTC+03:00) Nairobi"
  },
  {
    "id": "Africa/Kampala",
    "name": "(UTC+03:00) Nairobi"
  },
  {
    "id": "Africa/Kinshasa",
    "name": "(UTC+01:00) West Central Africa"
  },
  {
    "id": "Africa/Libreville",
    "name": "(UTC+01:00) West Central Africa"
  },
  {
    "id": "Africa/Lome",
    "name": "(UTC) Monrovia, Reykjavik"
  },
  {
    "id": "Africa/Kigali",
    "name": "(UTC+02:00) Harare, Pretoria"
  },
  {
    "id": "Africa/Luanda",
    "name": "(UTC+01:00) West Central Africa"
  },
  {
    "id": "Africa/Lubumbashi",
    "name": "(UTC+02:00) Harare, Pretoria"
  },
  {
    "id": "Africa/Lusaka",
    "name": "(UTC+02:00) Harare, Pretoria"
  },
  {
    "id": "Africa/Malabo",
    "name": "(UTC+01:00) West Central Africa"
  },
  {
    "id": "Africa/Mbabane",
    "name": "(UTC+02:00) Harare, Pretoria"
  },
  {
    "id": "Africa/Mogadishu",
    "name": "(UTC+03:00) Nairobi"
  },
  {
    "id": "Africa/Maseru",
    "name": "(UTC+02:00) Harare, Pretoria"
  },
  {
    "id": "Africa/Niamey",
    "name": "(UTC+01:00) West Central Africa"
  },
  {
    "id": "Africa/Nouakchott",
    "name": "(UTC) Monrovia, Reykjavik"
  },
  {
    "id": "Africa/Ouagadougou",
    "name": "(UTC) Monrovia, Reykjavik"
  },
  {
    "id": "Africa/Porto-Novo",
    "name": "(UTC+01:00) West Central Africa"
  },
  {
    "id": "America/Argentina/Salta",
    "name": "(UTC-03:00) Buenos Aires"
  },
  {
    "id": "America/Argentina/La_Rioja",
    "name": "(UTC-03:00) Buenos Aires"
  },
  {
    "id": "America/Argentina/Rio_Gallegos",
    "name": "(UTC-03:00) Buenos Aires"
  },
  {
    "id": "America/Argentina/San_Juan",
    "name": "(UTC-03:00) Buenos Aires"
  },
  {
    "id": "America/Argentina/San_Luis",
    "name": "(UTC-03:00) Buenos Aires"
  },
  {
    "id": "America/Argentina/Tucuman",
    "name": "(UTC-03:00) Buenos Aires"
  },
  {
    "id": "America/Argentina/Ushuaia",
    "name": "(UTC-03:00) Buenos Aires"
  },
  {
    "id": "America/Bahia_Banderas",
    "name": "(UTC-06:00) Guadalajara, Mexico City, Monterrey"
  },
  {
    "id": "America/Blanc-Sablon",
    "name": "(UTC-04:00) Georgetown, La Paz, Manaus, San Juan"
  },
  {
    "id": "America/Boise",
    "name": "(UTC-07:00) Mountain Time (US & Canada)"
  },
  {
    "id": "America/Cambridge_Bay",
    "name": "(UTC-07:00) Mountain Time (US & Canada)"
  },
  {
    "id": "America/Cambridge_Bay",
    "name": "(UTC-07:00) Mountain Time (US & Canada)"
  },
  {
    "id": "America/Chihuahua",
    "name": "(UTC-07:00) Chihuahua, La Paz, Mazatlan"
  },
  {
    "id": "America/Coral_Harbour",
    "name": "(UTC-05:00) Bogota, Lima, Quito"
  },
  {
    "id": "America/Creston",
    "name": "(UTC-07:00) Arizona"
  },
  {
    "id": "America/Detroit",
    "name": "(UTC-05:00) Eastern Time (US & Canada)"
  },
  {
    "id": "America/Detroit",
    "name": "(UTC-05:00) Eastern Time (US & Canada)"
  },
  {
    "id": "America/Dominica",
    "name": "(UTC-04:00) Georgetown, La Paz, Manaus, San Juan"
  },
  {
    "id": "America/Eirunepe",
    "name": "(UTC-05:00) Bogota, Lima, Quito"
  },
  {
    "id": "America/Glace_Bay",
    "name": "(UTC-04:00) Atlantic Time (Canada)"
  },
  {
    "id": "America/Goose_Bay",
    "name": "(UTC-04:00) Atlantic Time (Canada)"
  },
  {
    "id": "America/Indiana/Knox",
    "name": "(UTC-06:00) Central Time (US & Canada)"
  },
  {
    "id": "America/Indiana/Vincennes",
    "name": "(UTC-05:00) Eastern Time (US & Canada)"
  },
  {
    "id": "America/Indiana/Winamac",
    "name": "(UTC-05:00) Eastern Time (US & Canada)"
  },
  {
    "id": "America/Inuvik",
    "name": "(UTC-07:00) Mountain Time (US & Canada)"
  },
  {
    "id": "America/Juneau",
    "name": "(UTC-09:00) Alaska"
  },
  {
    "id": "America/Kentucky/Monticello",
    "name": "(UTC-05:00) Eastern Time (US & Canada)"
  },
  {
    "id": "America/Kralendijk",
    "name": "(UTC-04:00) Georgetown, La Paz, Manaus, San Juan"
  },
  {
    "id": "America/Matamoros",
    "name": "(UTC-06:00) Central Time (US & Canada)"
  },
  {
    "id": "America/Menominee",
    "name": "(UTC-06:00) Central Time (US & Canada)"
  },
  {
    "id": "America/Merida",
    "name": "(UTC-06:00) Guadalajara, Mexico City, Monterrey"
  },
  {
    "id": "America/Moncton",
    "name": "(UTC-04:00) Atlantic Time (Canada)"
  },
  {
    "id": "America/Monterrey",
    "name": "(UTC-06:00) Guadalajara, Mexico City, Monterrey"
  },
  {
    "id": "America/Montreal",
    "name": "(UTC-05:00) Eastern Time (US & Canada)"
  },
  {
    "id": "America/Nome",
    "name": "(UTC-09:00) Alaska"
  },
  {
    "id": "America/North_Dakota/Beulah",
    "name": "(UTC-06:00) Central Time (US & Canada)"
  },
  {
    "id": "America/North_Dakota/Center",
    "name": "(UTC-06:00) Central Time (US & Canada)"
  },
  {
    "id": "America/North_Dakota/New_Salem",
    "name": "(UTC-06:00) Central Time (US & Canada)"
  },
  {
    "id": "America/Ojinaga",
    "name": "(UTC-07:00) Mountain Time (US & Canada)"
  },
  {
    "id": "America/Pangnirtung",
    "name": "(UTC-05:00) Eastern Time (US & Canada)"
  },
  {
    "id": "America/Rankin_Inlet",
    "name": "(UTC-06:00) Central Time (US & Canada)"
  },
  {
    "id": "America/Rankin_Inlet",
    "name": "(UTC-06:00) Central Time (US & Canada)"
  },
  {
    "id": "America/Resolute",
    "name": "(UTC-06:00) Central Time (US & Canada)"
  },
  {
    "id": "America/Santa_Isabel",
    "name": "(UTC-08:00) Baja California"
  },
  {
    "id": "America/Santarem",
    "name": "(UTC-03:00) Cayenne, Fortaleza"
  },
  {
    "id": "America/Sitka",
    "name": "(UTC-09:00) Alaska"
  },
  {
    "id": "America/St_Lucia",
    "name": "(UTC-04:00) Georgetown, La Paz, Manaus, San Juan"
  },
  {
    "id": "America/St_Vincent",
    "name": "(UTC-04:00) Georgetown, La Paz, Manaus, San Juan"
  },
  {
    "id": "Arctic/Longyearbyen",
    "name": "(UTC+01:00) Amsterdam, Berlin, Bern, Rome, Stockholm, Vienna"
  },
  {
    "id": "Asia/Aden",
    "name": "(UTC+03:00) Kuwait, Riyadh"
  },
  {
    "id": "Asia/Anadyr",
    "name": "(UTC+12:00) Magadan"
  },
  {
    "id": "Asia/Kathmandu",
    "name": "(UTC+05:45) Kathmandu"
  },
  {
    "id": "Asia/Kuching",
    "name": "(UTC+08:00) Kuala Lumpur, Singapore"
  },
  {
    "id": "Asia/Muscat",
    "name": "(UTC+04:00) Abu Dhabi, Muscat"
  },
  {
    "id": "Asia/Novokuznetsk",
    "name": "(UTC+07:00) Novosibirsk"
  },
  {
    "id": "Asia/Novosibirsk",
    "name": "(UTC+07:00) Novosibirsk"
  },
  {
    "id": "Asia/Phnom_Penh",
    "name": "(UTC+07:00) Bangkok, Hanoi, Jakarta"
  },
  {
    "id": "Asia/Pontianak",
    "name": "(UTC+07:00) Bangkok, Hanoi, Jakarta"
  },
  {
    "id": "Asia/Qyzylorda",
    "name": "(UTC+06:00) Nur-Sultan (Astana)"
  },
  {
    "id": "Asia/Sakhalin",
    "name": "(UTC+11:00) Vladivostok"
  },
  {
    "id": "Asia/Samarkand",
    "name": "(UTC+05:00) Ashgabat, Tashkent"
  },
  {
    "id": "Asia/Urumqi",
    "name": "(UTC+06:00) Nur-Sultan (Astana)"
  },
  {
    "id": "Asia/Vientiane",
    "name": "(UTC+07:00) Bangkok, Hanoi, Jakarta"
  },
  {
    "id": "Atlantic/Madeira",
    "name": "(UTC) Dublin, Lisbon"
  },
  {
    "id": "Atlantic/St_Helena",
    "name": "(UTC) Monrovia, Reykjavik"
  },
  {
    "id": "Australia/Broken_Hill",
    "name": "(UTC+09:30) Adelaide"
  },
  {
    "id": "Australia/Melbourne",
    "name": "(UTC+10:00) Canberra, Melbourne, Sydney"
  },
  {
    "id": "Europe/Bratislava",
    "name": "(UTC+01:00) Belgrade, Bratislava, Budapest, Ljubljana, Prague"
  },
  {
    "id": "Europe/Isle_of_Man",
    "name": "(UTC) Edinburgh, London"
  },
  {
    "id": "Europe/Isle_of_Man",
    "name": "(UTC+01:00) Edinburgh, London"
  },
  {
    "id": "Europe/Ljubljana",
    "name": "(UTC+01:00) Belgrade, Bratislava, Budapest, Ljubljana, Prague"
  },
  {
    "id": "Europe/Podgorica",
    "name": "(UTC+01:00) Belgrade, Bratislava, Budapest, Ljubljana, Prague"
  },
  {
    "id": "Europe/Sarajevo",
    "name": "(UTC+01:00) Sarajevo, Skopje, Warsaw, Zagreb"
  },
  {
    "id": "Europe/Simferopol",
    "name": "(UTC+03:00) Moscow, St. Petersburg, Volgograd, Minsk"
  },
  {
    "id": "Europe/Skopje",
    "name": "(UTC+01:00) Sarajevo, Skopje, Warsaw, Zagreb"
  },
  {
    "id": "Europe/Uzhgorod",
    "name": "(UTC+02:00) E. Europe"
  },
  {
    "id": "Europe/Uzhgorod",
    "name": "(UTC+02:00) Helsinki, Kyiv, Riga, Sofia, Tallinn, Vilnius"
  },
  {
    "id": "Europe/Vaduz",
    "name": "(UTC+01:00) Amsterdam, Berlin, Bern, Rome, Stockholm, Vienna"
  },
  {
    "id": "Europe/Volgograd",
    "name": "(UTC+03:00) Moscow, St. Petersburg, Volgograd, Minsk"
  },
  {
    "id": "Europe/Zagreb",
    "name": "(UTC+01:00) Sarajevo, Skopje, Warsaw, Zagreb"
  },
  {
    "id": "Europe/Zaporozhye",
    "name": "(UTC+02:00) E. Europe"
  },
  {
    "id": "Europe/Zaporozhye",
    "name": "(UTC+02:00) Helsinki, Kyiv, Riga, Sofia, Tallinn, Vilnius"
  },
  {
    "id": "Indian/Antananarivo",
    "name": "(UTC+03:00) Nairobi"
  },
  {
    "id": "Indian/Comoro",
    "name": "(UTC+03:00) Nairobi"
  },
  {
    "id": "Indian/Mayotte",
    "name": "(UTC+03:00) Nairobi"
  },
  {
    "id": "Pacific/Johnston",
    "name": "(UTC-10:00) Hawaii"
  },
  {
    "id": "Pacific/Midway",
    "name": "(UTC-11:00) Coordinated Universal Time-11"
  },
  {
    "id": "Pacific/Saipan",
    "name": "(UTC+10:00) Guam, Port Moresby"
  }
];

export {
  TIMEZONE
};